export default function removeNodeNesting(nodes) {
  const result = Array.isArray(nodes) ? nodes.map(({ node }) => node) : []
  return result
}
